import {del, get, patch, post} from "./request";

/* // Async thunk to fetch offers from an API
export const fetchOffers = async ({page, size, ...props}) => {
  const response = await protectedAxiosInstance.post("offer/all", props, {
    page,
    size,
  }); // Replace with your API endpoint
  return response.data;
}; */

export const offerApi = {};
const apiResource = "/offer";

offerApi.getAll = async ({page, size, signal, ...props}) => {
  try {
    const {data} = await post(apiResource + `/all`, props, {page, size}, {signal});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.getMe = async ({page, size, signal, ...props}) => {
  try {
    const {data} = await post(apiResource + `/me/all`, props, {page, size}, {signal});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.getFavorites = async ({page, size, signal}) => {
  try {
    const {data} = await get(`/favoriteOffer/all`, {page, size}, {signal});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.addFavorite = async ({id}) => {
  try {
    const {data} = await post(`/favoriteOffer/add/${id}`, {});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
offerApi.removeFavorite = async ({id}) => {
  try {
    const {data} = await del(`/favoriteOffer/delete/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.getOne = async ({id, ...props}) => {
  try {
    const {data} = await get(apiResource + `/one/${id}`, props);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
offerApi.add = async ({body, onUploadProgress}) => {
  try {
    const {data} = await post(apiResource + `/add`, body, {}, {onUploadProgress});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.update = async ({id, body, onUploadProgress}) => {
  try {
    const {data} = await patch(
      apiResource + `/update/${id}`,
      body,
      {},
      {onUploadProgress},
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

offerApi.delete = async ({id}) => {
  try {
    const {data} = await del(apiResource + `/delete/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
